import { FormEvent, useEffect, useRef, useState } from "react";
import { Table } from "../../types/DealTracker";
import { toast } from "react-toastify";

type Props = {
  table: Table;
  onSubmit: (title: string) => Promise<void>;
  disabled: boolean;
};

export default function EditableText({ table, onSubmit, disabled }: Props) {
  const { title } = table;

  const [isEditable, setIsEditable] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditable) {
      inputRef.current?.focus();
    }
  }, [isEditable]);

  const handleDoubleClick = () => {
    if (disabled) return;
    setIsEditable(true);
  };

  const handleBlur = () => {
    (document.querySelector("#submit-btn") as HTMLInputElement).click();
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formdata = new FormData(e.currentTarget);
    const newTitle = String(formdata.get("title")).toString().trim();

    if (!title) {
      toast.warning("Title can not be empty!");
      return;
    }

    setIsEditable(false);

    await onSubmit(newTitle);
  };

  return isEditable ? (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        name="title"
        className="px-[10px] py-1 text-[0.9rem] text-[#333] rounded-md transition-colors duration-300 focus:border-[#d0d5dd] focus:outline-none focus:ring-2 focus:ring-[rgba(21,93,233,0.2)] placeholder:text-[#344054]"
        ref={inputRef}
        defaultValue={title}
        onBlur={handleBlur}
        required
        minLength={2}
      />
      <input type="submit" className="hidden" id="submit-btn" />
    </form>
  ) : (
    <h2
      className={`text-lg font-semibold ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      }`}
      onDoubleClick={handleDoubleClick}
    >
      {title}
    </h2>
  );
}
